import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { InvoicesStore2 } from './invoices.models'

const initialState: InvoicesStore2 = {
  newCFDI: {
    manualXMLUpload: {
      isDuplicatedModalOpen: false,
      duplicatedXMLs: [],
      isErrorModalOpen: false,
      errorXMLs: [],
      successXmlsAmount: 0,
      allXmlsAmount: 0,
      isMoreDetailsModalOpen: false
    },
  },
}

const invoicesSlice = createSlice({
  name: 'invoicesSlice',
  initialState,
  reducers: {
    setIsDuplicatedXMLsOpen(state, action: PayloadAction<boolean>) {
      state.newCFDI.manualXMLUpload.isDuplicatedModalOpen = action.payload
    },
    setDuplicatedXMLs(state, action: PayloadAction<string[]>) {
      state.newCFDI.manualXMLUpload.duplicatedXMLs = action.payload
    },
    setIsErrorXMLsOpen(state, action: PayloadAction<boolean>) {
      state.newCFDI.manualXMLUpload.isErrorModalOpen = action.payload
    },
    setErrorXMLs(state, action: PayloadAction<string[]>) {
      state.newCFDI.manualXMLUpload.errorXMLs = action.payload
    },
    setSuccesXmlsAmount(state, action: PayloadAction<number>) {
      state.newCFDI.manualXMLUpload.successXmlsAmount = action.payload
    },
    setAllXmlsAmount(state, action: PayloadAction<number>) {
      state.newCFDI.manualXMLUpload.allXmlsAmount = action.payload
    },
    setIsMoreDetailsModalOpen(state, action: PayloadAction<boolean>) {
      state.newCFDI.manualXMLUpload.isMoreDetailsModalOpen = action.payload
    }
    
  }
})

export const {
  setIsDuplicatedXMLsOpen,
  setDuplicatedXMLs,
  setIsErrorXMLsOpen,
  setErrorXMLs,
  setSuccesXmlsAmount,
  setAllXmlsAmount,
  setIsMoreDetailsModalOpen
} = invoicesSlice.actions

export default invoicesSlice.reducer
